import ConsentInner from './ConsentInner';

const Consent = () => {
  return <ConsentInner variant="microsoft365" />;
};

export default Consent;
